import {injectable} from "inversify";
import {Match} from "@/modules/match/entity";
import _ from "lodash";
import {KODivision, Matchday} from "@/modules/competitions/entity";
import {Season} from "@/modules/season/entity";
import {FindManyOptions} from "typeorm";

@injectable()
export default class KODivisionMatchGenerator {
  async generate(season: Season, division: KODivision) {
    if (division.finished) {
      throw 'Division is finished already.';
    }

    const matchdays = await Matchday.find({
      where: {
        division: {
          id: division.id,
        },
        season: {
          id: season.id,
        },
      },
      relations: {
        division: true,
        season: true,
      }
    } as FindManyOptions);

    await division.load(['teams', 'matchdays']);

    const homeMatchday = matchdays[0];
    await homeMatchday.load('matches');

    const awayMatchday = matchdays[1];
    if (awayMatchday) {
      await awayMatchday.load('matches');
    }

    if (homeMatchday.matches.length > 0 || (awayMatchday && awayMatchday.matches.length > 0)) {
      throw 'There are already games inside this division matchdays';
    }

    const pairs = _.chain(division.teams).shuffle().chunk(2).value();

    for (const [homeTeam, awayTeam] of pairs) {
      const homeMatch = new Match();
      homeMatch.homeTeam = homeTeam;
      homeMatch.awayTeam = awayTeam;
      homeMatch.matchday = homeMatchday;
      homeMatch.needDecision = !awayMatchday;
      await homeMatch.save();
      console.debug('KODivisionMatchGenerator::generate Generated home match', homeMatch);

      if (awayMatchday) {
        const awayMatch = new Match();
        awayMatch.homeTeam = awayTeam;
        awayMatch.awayTeam = homeTeam;
        awayMatch.matchday = awayMatchday;
        awayMatch.connectedMatch = homeMatch;
        awayMatch.needDecision = true;
        await awayMatch.save();

        homeMatch.connectedMatch = awayMatch;
        await homeMatch.save();
        console.debug('KODivisionMatchGenerator::generate Generated away match', awayMatch);
      }
    }
  }
}